<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P3Zayu/tc-custom/9781605099057.jpg?1725276352349" alt="This image is the cover for the book Nonverbal Advantage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nonverbal Advantage
      </h1>
      <p class="bookDescription body article font2">
        <b>What are you saying when you’re not speaking? A top consultant “shows you how to use body language skills to build stronger professional relationships”</b> (<b>Robert L. Dilenschneider, author of <i>The Ultimate Guide to Power and Influence</i>).</b><br/>  <br/><i>How is the audience reacting to my presentation? Should I believe what my boss just told me? Is this person a potential buyer, or am I just wasting my time? How do I know if the CEO really supports my idea?</i><br/>  <br/> Studies show that ninety-three percent of the messages people receive from us—and that we receive from them—have nothing to do with the words that are said. Therefore, strong nonverbal communication skills are a huge professional advantage, but until now little information has been available about how to hone the ability to use and interpret body language on the job.<br/>  <br/> In <i>The Nonverbal Advantage</i>, Carol Kinsey Goman combines the latest research and her twenty-five years of practical experience as a consultant, coach, and therapist to offer a fun and practical guide to understanding what we and the people we work with are saying without speaking. While firmly grounded in recent discoveries in evolutionary psychology, neurobiology, sociology, criminology, anthropology, and communication studies, Goman’s book is written in an informal, conversational tone and illustrates her points with cartoons, photos, and entertaining anecdotes. She also includes a chapter on translating body language across different cultures, and dozens of simple, enlightening exercises you can practice on and off the job—to gain control over the message you’re sending.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Kinsey Goman
      </h2>
      
      <p class="authorDescription body article">Carol Kinsey Goman, PhD, is president of Kinsey Consulting Services. She has worked with over 130 organizations in twenty-one countries. Her work has been featured on CNN, Bloomberg Television, and NBC News.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?298eb186